import React, { ComponentProps } from 'react';
import { Button } from '@common/components';

export function SubmitButton({
  children,
  ...props
}: Omit<ComponentProps<typeof Button>, 'htmlType'>) {
  return (
    <Button kind="primary" {...props} htmlType="submit">
      {children}
    </Button>
  );
}
